import { useState, useCallback, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';

const determineSize = element => {
  if (
    !element
    || typeof window === 'undefined'
  ) return { width: 0, height: 0 };
  const width = element.contentRect?.width || element.clientWidth || element.offsetWidth;
  const height = element.contentRect?.height || element.clientHeight || element.offsetHeight;

  return { width, height };
};

const useScreen = (element = null) => {
  let elToUse = element;
  if (
    !element
    && typeof document !== 'undefined'
  ) {
    elToUse = document.documentElement;
  }
  const elRef = useRef(elToUse);
  const [state, setState] = useState({ width: 0, height: 0 });
  const screenObserver = useRef(null);

  const resizeObserverCb = useCallback(
    throttle(entries => {
      const [entry] = entries;
      setState(determineSize(entry.target));
    }, 250, { leading: false, trailing: true }),
    []
  );

  useEffect(() => {
    if (
      typeof ResizeObserver !== 'undefined'
      && !screenObserver.current
    ) {
      screenObserver.current = new ResizeObserver(resizeObserverCb);
    }
    const $element = elRef.current;
    if ($element) {
      setState(determineSize($element));
      if (screenObserver.current) {
        screenObserver.current.observe($element);
      }
    }
    return () => {
      if (
        $element
        && screenObserver.current
      ) {
        screenObserver.current.unobserve($element);
      }
    };
  }, [elRef]);

  return state;
};

export default useScreen;
